import { env } from 'common/env'
import { Configuration } from './configuration'
import { callBackend } from './fetch'

export const configuration: Configuration = {
    basePath: env.endpoint
}

export abstract class BaseApi {
    protected fetch = callBackend
}
